import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0957f47c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "nodata",
  style: {
    "margin": "0 auto",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_tab = _resolveComponent("van-tab");
  const _component_van_tabs = _resolveComponent("van-tabs");
  const _component_van_col = _resolveComponent("van-col");
  const _component_van_row = _resolveComponent("van-row");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_van_tabs, {
    active: $setup.active,
    "onUpdate:active": _cache[0] || (_cache[0] = $event => $setup.active = $event),
    class: "acclass",
    onClickTab: $options.onClickTab,
    color: "#Fdd100",
    "title-active-color": "#Fdd100"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "未完成"
    }), _createVNode(_component_van_tab, {
      title: "已完成"
    }), _createVNode(_component_van_tab, {
      title: "已完成評價"
    })]),
    _: 1
  }, 8, ["active", "onClickTab"]), _createVNode(_component_van_row, {
    justify: "center",
    gutter: "20",
    style: {
      "margin-top": "44px",
      "margin-bottom": "44px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_van_col, {
      span: "22"
    }, {
      default: _withCtx(() => [_createVNode(_component_van_pull_refresh, {
        modelValue: $setup.refreshing,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $setup.refreshing = $event),
        onRefresh: $options.onRefresh
      }, {
        default: _withCtx(() => [_withDirectives(_createVNode(_component_van_list, {
          loading: $setup.loading,
          "onUpdate:loading": _cache[1] || (_cache[1] = $event => $setup.loading = $event),
          finished: $setup.finished,
          "finished-text": "沒有更多了",
          onLoad: $options.onLoad
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, item => {
            return _openBlock(), _createBlock(_component_van_row, {
              justify: "center",
              class: "car_class",
              key: item,
              onClick: $event => $options.ToUrl(item)
            }, {
              default: _withCtx(() => [_createVNode(_component_van_col, {
                span: "24",
                style: {
                  "padding": "10px 0px",
                  "border-bottom": "2px solid #F2F2F2",
                  "margin-bottom": "5px",
                  "font-weight": "bold"
                }
              }, {
                default: _withCtx(() => [_createTextVNode(" 單號: " + _toDisplayString(item.orderNumber), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 服務類型: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.serviceType == 1 ? '報修' : '保養'), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 報修來源: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.source == 'WECOM' ? '委託報修' : '自行報修'), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 提交人員: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.source == 'WECOM' ? item.sourceName : item.linkman), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 設備型號: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.model), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 設備序號: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.sn), 1)]),
                _: 2
              }, 1024), _createVNode(_component_van_col, {
                span: "6",
                class: "ctitle"
              }, {
                default: _withCtx(() => [_createTextVNode(" 提交時間: ")]),
                _: 1
              }), _createVNode(_component_van_col, {
                span: "18",
                class: "ctext"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.creationTimeStr), 1)]),
                _: 2
              }, 1024)]),
              _: 2
            }, 1032, ["onClick"]);
          }), 128))]),
          _: 1
        }, 8, ["loading", "finished", "onLoad"]), [[_vShow, !$setup.NotFind]])]),
        _: 1
      }, 8, ["modelValue", "onRefresh"])]),
      _: 1
    })]),
    _: 1
  }), _withDirectives(_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_empty, {
    description: "暫無數據"
  })], 512), [[_vShow, $setup.NotFind]]), _createVNode(_component_van_button, {
    class: "btnClass",
    block: "",
    type: "default",
    onClick: _cache[3] || (_cache[3] = $event => this.$router.go(-1))
  }, {
    default: _withCtx(() => [_createTextVNode(" 返回 ")]),
    _: 1
  })], 64);
}